<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="title"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section>
      <!-- <section class="posiab tipBox error"> -->
      <section v-show="downloadTipsShow">
        <section
            class="tipBox error"
        >温馨提示：<span v-show="tipDesc1">1、</span>必须使用系统提供的模板，按照模板填写对应的数据后再导入。导入后请前往“系统管理 - 导入导出结果查询”中查看导入结果。最多一次性导入300条数据。</section>
        <section class="tipBox error">{{tipDesc1 || ''}}</section>
        <section class="tipBox error">{{tipDesc2 || ''}}</section>
        <section class="tipBox error">{{tipDesc3 || ''}}</section>

        <section class="tmplFile clearPa" v-show="fileUrl">
          <div class="left">{{ downloadDesc || '文件模板'}}：</div>
          <div class="left">
            <p
                class="primary cur"
                @click="customDownload(url, index)"
                v-for="(url, index) in arrTmpl"
                :key="url"
            >{{ url.replace('/file/','') }}</p>
          </div>
        </section>
      </section>
      <div style="padding-bottom: 16px" v-show="!fileUrl"></div>
      <div class="btnBox">
        导入文件：
        <el-button @click="chooseFile(fileType)" type="primary" plain>选择文件</el-button>
      </div>
      <div class="filename" v-if="fileData">{{ fileData.name }}</div>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="sub" :loading="subLoading">上传</el-button>
    </section>
  </el-dialog>
</template>

<script>
import { downloadBinaryFile } from 'api';
export default {
  props: {
    title: {
      type: String,
      default: '导入',
    },
    fileUrl: {
      default: '',
    },
    bizCodes: {
      default: '',
    },
    // 设置选择文件的格式
    fileType: {
      type: String,
      default: '',
    },
    downloadTipsShow: {
      type: Boolean,
      default: true,
    },
    tipDesc1: {
      type: String,
      default: '',
    },
    tipDesc2: {
      type: String,
      default: '',
    },
    tipDesc3: {
      type: String,
      default: '',
    },
    downloadDesc: {
      type: String,
      default: '',
    },
    isDownloadLocalTemplate: {
      type: Boolean,
      default: false,
    },
    isCustomDownload: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      fileData: null,
    };
  },
  computed: {
    arrTmpl () {
      if (!this.fileUrl) {
        return [];
      } else if (this.fileUrl instanceof Array) {
        return this.fileUrl;
      } else {
        return [this.fileUrl];
      }
    },
  },
  methods: {

    customDownload (url, index) {
      if (this.isDownloadLocalTemplate) {
        // 下载本地模板，直接打开 url 下载即可
        window.open(url);
      } else if (this.bizCodes && !this.isDownloadLocalTemplate) {
        // 下载服务端的模板，根据 bizCode 去下载服务器的模板
        const bizCode = Array.isArray(this.bizCodes) ? this.bizCodes[index] : this.bizCodes;
        if (bizCode) {
          downloadBinaryFile({
            url: `/sysImportBO.ajax?cmd=downloadExcelFile&bizCode=${bizCode}`,
          });
        }
      } else if (this.isCustomDownload) {
        // 自定义下载操作
        this.$emit('customDownload');
      } else {
        this.$message.warning('缺少模板下载设置参数');
      }
    },

    chooseFile (val) {
      // val为设置选择文件格式的传参，此处修改基于订单批量导入固定和临时线路只支持选择压缩包
      let domInput = document.createElement('input');
      if (val === 'package') {
        domInput.setAttribute('accept', '.rar,.zip'); // 限制选择的文件
      } else {
        domInput.setAttribute('accept', 'xlsx'); // 限制选择的文件
      }
      domInput.setAttribute('type', 'file'); // 设置为上传文件
      domInput.setAttribute('multiple', false); // 设置可否为多选
      domInput.onchange = async () => {
        if (val === 'package') {
          let fileType = domInput.files[0] && domInput.files[0].name.substring(domInput.files[0].name.lastIndexOf('.') + 1);
          if (fileType !== 'zip' && fileType !== 'rar') {
            this.$message.error('上传文件仅支持zip、rar格式');
          } else {
            this.fileData = domInput.files[0];
            domInput = null;
          }
        } else {
          this.fileData = domInput.files[0];
          domInput = null;
        }
      };
      domInput.click();
    },

    /**
     * @param {Object} visible 展示状态
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (visible) {
      this.dialogFormVisible = visible; // 打开弹窗
      this.fileData = null;
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub () {
      if (!this.fileData) {
        this.$message({
          type: 'warning',
          message: '请选择要上传的文件',
        });
        return;
      }
      this.$emit('sub', this.fileData);
    },
  },
};
</script>

<style scoped lang="scss">
.tipBox {
  line-height: 18px;
  background: #f0f2f5;
  width: 100%;
  top: 80px;
  left: 0;
  padding: 6px 24px;
  box-sizing: border-box;

  .tipFirst{
    white-space: pre-wrap;
  }
}
::v-deep .el-alert__content {
  line-height: 24px;
}
.tmplFile {
  margin-bottom: 16px;
  margin-top: 16px;
  color: #999;
  // padding-top: 64px;
}
.btnBox {
  color: #999;
  margin-bottom: 16px;
}
.filename {
  color: #999;
  padding-left: 72px;
}
</style>
